import repoUrls from 'src/sections/repository/urls';
import { urls as projectUrls } from 'src/urls/projects';
import { urls as workspaceUrls } from 'src/urls/workspaces';

import {
  PACKAGE_TYPE_QUERY_PARAM,
  PACKAGES_PAGE_LENGTH,
  PAGE_QUERY_PARAM,
  PAGELEN_QUERY_PARAM,
  SEARCH_PACKAGE_NAME_QUERY_PARAM,
  SORT_QUERY_PARAM,
} from '../constants';
import { Package, PackagesResponse } from '../types';
import { buildPackagesApiQueryString } from '../utils';

import { packagesResourceFactory } from './utils';

export const packagesResource = packagesResourceFactory<PackagesResponse>()({
  key: 'packages-list',
  // This being the root packages page, we only have the common
  // workspace/project/repository params on the route, so we specify an empty
  // array here
  pathParamNames: [] as const,
  queryParamNames: [
    SORT_QUERY_PARAM,
    PAGE_QUERY_PARAM,
    SEARCH_PACKAGE_NAME_QUERY_PARAM,
    PACKAGE_TYPE_QUERY_PARAM,
  ] as const,
  getRequestUrl: (context, _pathParams, queryParams) => {
    const queryString = buildPackagesApiQueryString({
      ...queryParams,
      [PAGELEN_QUERY_PARAM]: PACKAGES_PAGE_LENGTH.toString(),
    });

    switch (context.container) {
      case 'workspace':
        return workspaceUrls.api.internal.getPackages(
          context.workspaceSlug,
          queryString
        );
      case 'project':
        return projectUrls.api.internal.getPackages(
          context.workspaceSlug,
          context.projectKey,
          queryString
        );
      case 'repository':
        return repoUrls.api.internal.packages(
          context.workspaceSlug,
          context.repositorySlug,
          queryString
        );
      default:
        throw new Error('Invalid route context');
    }
  },
  transformResponse: (response: PackagesResponse): PackagesResponse => ({
    ...response,
    values: response.values.filter(
      (pkg: Package) => pkg.repository.full_name && pkg.repository.name
    ),
  }),
});
